/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getImageAlbums = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Image Album query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-image-album/get?${queryString}`);
};

export const getImageAlbumById = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-image-album/${id}`);
};

export const getImageAlbumByMID = (mid) => {
  return API.get(`${getApiUrl()}/api/tkt1-image-album/get-by-mid/${mid}`);
};

export const createImageAlbum = (albumData) => {
  return API.post(`${getApiUrl()}/api/tkt1-image-album/create`, albumData);
};

export const updateImageAlbum = (id, albumData) => {
  return API.put(`${getApiUrl()}/api/tkt1-image-album/${id}`, albumData);
};

export const deleteImageAlbum = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-image-album/${id}`);
};

export const tkt1ImageAlbumService = {
  getImageAlbums,
  getImageAlbumById,
  getImageAlbumByMID,
  createImageAlbum,
  updateImageAlbum,
  deleteImageAlbum
};
